module.exports = __webpack_public_path__ + "static/media/info-tooltip.9e44ac1b.png";